import React from 'react';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import { LineChartOutlined } from '@ant-design/icons';
import { Row, Form as AntForm } from 'antd';
import { CollapseBlock } from '../../../../common/index.jsx';
import { DATETIME_FORMAT_DATETIME } from '../../../../../utils/helpers/CommonHelper.jsx';
import FormRangeDatePicker from '../../../../antd/form/FormRangeDatePicker/FormRangeDatePicker.jsx';
import Form from '../../../../antd/form/Form/Form.jsx';
import { SubmitButton } from '../../../../common/form/FormElements.jsx';
import { SensorAttributeSelect } from './SensorAttributeSelect.jsx';
import { required } from '../../../../antd/form/FormValidation.js';
import { PredefinedRangeDatePickerValues } from './PredefinedRangeDatePickerValues.jsx';

export function ParametersForm({ onSubmit, sensorsWithGraphableAttributes }) {
  const { t } = useTranslation();
  const [form] = AntForm.useForm();

  return (
    <Form onFinish={onSubmit} form={form}>
      <CollapseBlock collapsible title={t('Parametre')}>
        <div className="meteo-station-parameter-form-wrapper">
          <article>
            <h3 className="meteo-station-tip-title">
              1. {t('Vyberte, ktoré atribúty senzorov chcete použiť')}
            </h3>

            <SensorAttributeSelect
              name={'sensor_attribute_ids'}
              label={t('Atribúty senzorov')}
              multiple
              sensorWithAttributes={sensorsWithGraphableAttributes}
            />
          </article>

          <article>
            <h3 className="meteo-station-tip-title">
              2. {t('Vyberte časové obdobie')}
            </h3>

            <FormRangeDatePicker
              label={t('Časové obdobie')}
              name={'dates'}
              className="meteo-station-field"
              showTime
              format={DATETIME_FORMAT_DATETIME}
              disabledDate={(current) =>
                current && current > dayjs().endOf('day')
              }
              rules={[required(t)]}
            />

            <PredefinedRangeDatePickerValues
              onValueChange={(value) => form.setFieldValue('dates', value)}
            />
          </article>
        </div>

        <Row justify={'start'}>
          <SubmitButton icon={<LineChartOutlined />}>
            {t('Zobraziť vývoj v grafe')}
          </SubmitButton>
        </Row>
      </CollapseBlock>
    </Form>
  );
}
